import { useEffect, useState } from "react";
import { DeviceMobile, X, Share } from "@phosphor-icons/react";

const DISMISS_KEY = "pwa_install_dismissed";

const isIOS = () =>
  /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;

const staatAlGeinstalleerd = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

export const InstallBanner = () => {
  const [prompt, setPrompt] = useState(null);
  const [iosTip, setIosTip] = useState(false);

  useEffect(() => {
    if (staatAlGeinstalleerd() || localStorage.getItem(DISMISS_KEY)) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    // iOS kent beforeinstallprompt niet: daar tonen we een korte uitleg
    const t = isIOS() ? setTimeout(() => setIosTip(true), 1500) : null;

    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      if (t) clearTimeout(t);
    };
  }, []);

  const sluit = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setPrompt(null);
    setIosTip(false);
  };

  const installeer = async () => {
    if (!prompt) return;
    prompt.prompt();
    const keuze = await prompt.userChoice;
    if (keuze?.outcome === "accepted") localStorage.setItem(DISMISS_KEY, "1");
    setPrompt(null);
  };

  if (!prompt && !iosTip) return null;

  return (
    <div
      className="fixed bottom-3 left-3 right-3 z-[60] sm:left-auto sm:right-4 sm:w-[380px] bg-[#002FA7] text-white rounded-sm shadow-xl border border-white/15 p-3 flex items-start gap-3"
      data-testid="pwa-install-banner"
    >
      <div className="w-10 h-10 rounded-sm bg-white/15 flex items-center justify-center shrink-0">
        <DeviceMobile size={22} weight="bold" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm">App installeren</p>
        {prompt ? (
          <p className="text-xs opacity-80 mt-0.5">
            Zet Personeel Register op je startscherm — opent zonder browserbalk.
          </p>
        ) : (
          <p className="text-xs opacity-80 mt-0.5 flex items-center gap-1">
            Tik op <Share size={13} weight="bold" /> en daarna op "Zet op beginscherm".
          </p>
        )}
        {prompt && (
          <button
            onClick={installeer}
            className="mt-2 h-9 px-4 rounded-sm bg-white text-[#002FA7] text-sm font-bold active:scale-[0.98] transition-transform"
            data-testid="pwa-install-btn"
          >
            Installeren
          </button>
        )}
      </div>
      <button
        onClick={sluit}
        className="p-1 rounded-sm hover:bg-white/15 shrink-0"
        aria-label="Sluiten"
        data-testid="pwa-install-close"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
};
